/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m11.6943873 10.2160115c.4074836.4085151.4074836 1.0698707 0 1.4783858-.4085284.4074703-1.0699056.4074703-1.4784341 0l-2.2160838-2.2170563-2.21608385 2.2170563c-.40852842.4074703-1.06990564.4074703-1.47738923 0-.40852843-.4085151-.40852843-1.0698707 0-1.4783858l2.21608384-2.2160115-2.21608384-2.21601149c-.40852843-.40851509-.40852843-1.06987071 0-1.47838579.40748359-.40747029 1.06886081-.40747029 1.47738923 0l2.21608385 2.21705628 2.2160838-2.21705628c.4085285-.40747029 1.0699057-.40747029 1.4784341 0 .4074836.40851508.4074836 1.0698707 0 1.47838579l-2.21712867 2.21601149z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;